import { supabase } from "@/integrations/supabase/client";

export interface MentorRating {
  averageRating: number;
  totalReviews: number;
}

/**
 * Busca a avaliação média de um mentor específico
 */
export const getMentorRating = async (mentorId: string): Promise<MentorRating> => {
  try {
    console.log('⭐ [getMentorRating] Buscando rating para mentor ID:', mentorId);
    
    // Buscar ratings usando mentor_id
    const { data: reviews, error } = await supabase
      .from('session_reviews')
      .select('rating')
      .eq('mentor_id', mentorId);

    console.log('⭐ [getMentorRating] Reviews encontradas:', { count: reviews?.length || 0, error });

    if (error) {
      console.error('Error fetching mentor ratings:', error);
      return { averageRating: 0, totalReviews: 0 };
    }

    if (!reviews || reviews.length === 0) {
      return { averageRating: 0, totalReviews: 0 };
    }

    const totalRating = reviews.reduce((sum, review) => sum + review.rating, 0);
    const averageRating = parseFloat((totalRating / reviews.length).toFixed(1));

    return {
      averageRating,
      totalReviews: reviews.length
    };
  } catch (error) {
    console.error('Error in getMentorRating:', error);
    return { averageRating: 0, totalReviews: 0 };
  }
};

/**
 * Busca as avaliações de vários mentores de uma vez
 */
export const getMultipleMentorRatings = async (mentorIds: string[]): Promise<Record<string, MentorRating>> => {
  try {
    if (mentorIds.length === 0) return {};

    console.log('⭐ [getMultipleMentorRatings] Buscando ratings para múltiplos mentores:', mentorIds.length);

    // Buscar ratings usando mentor_id
    const { data: reviews, error } = await supabase
      .from('session_reviews')
      .select('rating, mentor_id')
      .in('mentor_id', mentorIds);

    console.log('⭐ [getMultipleMentorRatings] Reviews encontradas:', { count: reviews?.length || 0, error });

    if (error) {
      console.error('Error fetching multiple mentor ratings:', error);
      return {};
    }

    // Agrupar reviews por mentor_id
    const groupedReviews: Record<string, number[]> = {};
    
    reviews?.forEach(review => {
      if (!groupedReviews[review.mentor_id]) {
        groupedReviews[review.mentor_id] = [];
      }
      groupedReviews[review.mentor_id].push(review.rating);
    });

    // Calcular média para cada mentor
    const result: Record<string, MentorRating> = {};
    
    mentorIds.forEach(mentorId => {
      const mentorReviews = groupedReviews[mentorId] || [];
      
      if (mentorReviews.length === 0) {
        result[mentorId] = { averageRating: 0, totalReviews: 0 };
      } else {
        const totalRating = mentorReviews.reduce((sum, rating) => sum + rating, 0);
        const averageRating = parseFloat((totalRating / mentorReviews.length).toFixed(1));
        
        result[mentorId] = {
          averageRating,
          totalReviews: mentorReviews.length
        };
      }
    });

    return result;
  } catch (error) {
    console.error('Error in getMultipleMentorRatings:', error);
    return {};
  }
}; 